import { mkBillerLogin } from './billerLoginsTypes';

export const transformResponseToBillerLogins = (response) => {
  // TODO: remove if QCS makes consistent
  const resourceObject = response.data.resources || response.data;
  return resourceObject.map((data) => mkBillerLogin({ ...data }));
};

// used for get and delete mostly
// (theoretically could be used for update but currently we dont update outside billerDiscovery)
export const transformBillerLoginToRequestData = (billerLogin) => ({
  id: billerLogin.id ? billerLogin.id : null,
  name: billerLogin.name || null,
  // TODO: maybe more
  providerBillerID: billerLogin.providerBillerLoginID,
  credentialAnswers: billerLogin.credentialAnswers,
});

export const transformBillerLoginToCreateRequestData = (billerLogin) => ({
  providerBillerID: billerLogin.providerBillerID,
  credentialAnswers: billerLogin.credentialAnswers,
  isEncryptionEnabled: billerLogin.isEncryptionEnabled,
  credentials: billerLogin.credentials,
  fieldEncryptionId: billerLogin.fieldEncryptionId,
});

export const transformBillerLoginToUpdateRequestData = (billerLogin) => ({
  id: billerLogin.id,
  providerBillerID: billerLogin.providerBillerID,
  credentialAnswers: billerLogin.credentialAnswers,
  isEncryptionEnabled: billerLogin.isEncryptionEnabled,
  credentials: billerLogin.credentials,
  fieldEncryptionId: billerLogin.fieldEncryptionId,
});
